import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

const NAV_CLASSES = 'tw:flex! tw:w-fit tw:gap-8 tw:items-start tw:border-b tw:border-solid '
  + 'tw:border-gray-300'

const TAB_BASE = 'tw:bg-transparent tw:border-0 tw:cursor-pointer tw:pb-2 '
  + 'tw:text-sm tw:font-medium tw:border-b tw:border-solid tw:-mb-px!'
const TAB_ACTIVE = {
  primary: 'tw:text-ds-primary tw:border-ds-primary',
  neutral: 'tw:text-ds-neutral-highest tw:border-ds-neutral-highest'
}
const TAB_INACTIVE = 'tw:text-gray-500 tw:border-transparent '
  + 'tw:hover:text-ds-neutral-highest'

// Opt-in vertical rule before an item, to group tabs that belong together
// (same `dividerBefore` contract as ui/ActionsMenu).
const DIVIDER_CLASS = 'tw:self-center tw:w-px tw:h-4.5 tw:bg-gray-300 tw:shrink-0'

const tabClassName = (isActive, variant) =>
  `${TAB_BASE} ${isActive ? TAB_ACTIVE[variant] : TAB_INACTIVE}`

const Tabs = ({ items, value, onChange, variant = 'primary', className = '' }) => {
  const handleClick = useCallback(event => {
    onChange(event.currentTarget.dataset.value)
  }, [onChange])

  return (
    <nav className={`${NAV_CLASSES} ${className}`}>
      {items.map(item => (
        <React.Fragment key={item.value}>
          {item.dividerBefore ? <span aria-hidden="true" className={DIVIDER_CLASS} /> : null}
          <button
            className={tabClassName(item.value === value, variant)}
            data-value={item.value}
            type="button"
            onClick={handleClick}
          >
            {item.label}
          </button>
        </React.Fragment>
      ))}
    </nav>
  )
}

Tabs.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    dividerBefore: PropTypes.bool,
    label: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'neutral'])
}

Tabs.defaultProps = {
  className: '',
  variant: 'primary'
}

export default Tabs
